module.exports = __webpack_public_path__ + "static/media/no-unresolve.8c560789.svg";